export const adminLoginPath = '/user/login';

export function isAdminAuthPath(pathname?: string | null) {
  return (pathname || '').startsWith('/user');
}

export function getAdminToken() {
  return localStorage.getItem('admin_token')?.trim() || '';
}

export function shouldFetchCurrentUser(pathname?: string | null, token?: string | null) {
  return !isAdminAuthPath(pathname) && Boolean((token || '').trim());
}

export function shouldSilenceAuthError(pathname?: string | null) {
  return isAdminAuthPath(pathname);
}
